// extracted by mini-css-extract-plugin
export default {"gif":"m_bp","gif--wrapped":"m_bq"};